import React, { useState, useEffect } from "react";
import CompanySearch from "../../../../components/common/forms/CompanySearch";
import DetailsOfShareHolders from "../../../../components/common/forms/DetailsOfShareHolders";
import FormBranch from "../../../../components/common/forms/FormBranch";
import FormButtom from "../../../../components/common/forms/FormButtom";
import FormUploadDocument from "../../../../components/common/forms/FormUploadDocument";
import MainObjectives from "../../../../components/common/forms/MainObjectives";
import {
  Ward_upload_details_v2,
  Ward_details_of_shareholder_v2,
  ward_shareholder_v2,
  ward_registration_v3,
} from "../WardRegistrationForm";
import { useForm } from "react-hook-form";
import FormPayment from "../../../../components/common/forms/FormPayment";
import Documents from "../../../../components/common/forms/Documents";
import { v4 as uuidv4 } from "uuid";
import api from "../../../../api/api";
import PrivateCompanyModal from "../../../../components/common/modal/CompanyFeeModal";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import AdminSearchCustomer from "../../common/AdminSearchCustomer";


const WardRegistrationB = () => {
  const { register, handleSubmit, unregister } = useForm();

  const [shareHolders, setShareHolders] = useState([
    {
      ...ward_shareholder_v2,
      id: uuidv4(),
    },
  ]);
  const [docsOutput, setDocsOutput] = useState([]);
  const [uploadProof, setUploadProof] = useState('')

  
  const { user, isSuccess } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null)

  const [paymentRangeList, setPaymentList] = useState([]);
  const [amount, setAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [dueAmount, setDueAmount] = useState(null);
  const [paidAmount, setPaidAmount] = useState(null);

  // For amount calculation
  useEffect(() => {
    if (amount > 0) {
      let arr = paymentRangeList.filter((item) => {
        return (
          amount >= parseInt(item.range_start) &&
          amount <= parseInt(item.range_end)
        );
      });
      console.log(arr);

      arr.length > 0 && setTotalAmount(arr[0]?.amount);
    } else {
      setTotalAmount(0);
    }
  }, [amount, paymentRangeList]);

   // getting current user
   useEffect(() => {
    api
      .get("/users/me/")
      .then((response) => {
        setDueAmount(response.due_amount);
      })
      .catch((error) => {});
  }, []);

    // for filtering by company_type and show in Modal
    useEffect(() => {
      api.get('/services/company/registration/service-charges/?company_type=ward_prali')
      .then(response=> {
          // console.log(response.data)
          setPaymentList(response.data)
      }).catch(error=> {
         console.log(error)
      })
    }, [])


  


  

  const handleClick = (data) => {
    data.share_holders = shareHolders;
    data.documents = docsOutput;

    if (user?.user_type === "CL") {
      const user = JSON.parse(localStorage.getItem("user"));
      data.user = user.user_id;
    } else {
      if (userID !== null) {
        data.user = userID;
      }
    }

    api
      .post("services/company/", data)
      .then((response) => {
        toast.success("Data Registered Successfully");

        let transactions = {
          // payment_mode: "e_wallet",
          amount: paidAmount,
          service_object_id: response.data.registration_id,
          created_by: response.data.registration_id,
          service_object_content_type: response.data.service_content_type_id,
          payment_proof : uploadProof,
          company : response.data.company_id,
          transaction_type: "credit"
       
        };

        api
          .post("/transactions/", transactions)
          .then((response) => {
            toast.success("Data Registered 2 Successfully.");
          })
          .catch((error) => {
            toast.error("Error in Transaction");
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  let data = [];

  // creating initial state according to the length of documents
  Ward_upload_details_v2.map((item, i) => {
    data.push({ id: uuidv4(), image: "", document_name: "" });
    return "";
  });

  return (
    <div>
      <form className="">

      <div className="mt-3">
        {(user?.user_type === "ST" || user?.user_type === "AD") && (
          <AdminSearchCustomer setUserId={setUserId} />
        )}
      </div>
        {/*        
        <div className="flex justify-between">
          <p className="text-primary-red text-lg underline">
            1. Business Name & Other Details
          </p>
          <p className="text-primary-red flex">
            Firm No.
            <p className=" text-primary-blue"> 1234</p>
          </p>
        </div> */}
        <CompanySearch register={register} />
        <div className="border-2 mt-3 border-primary-blue">
        <div className="border-primary-blue flex text-primary-red  md:flex-row flex-col  w-full text-base font-bold  sm:text-lg">
          <div className=" px-5 py-2 border-priimary-blue md:w-[20%] md:border-r borer-r-0  border-primary-blue ">
            कम्पनीको नाम :
          </div>
          <div className=" px-5 border-t md:border-t-0 py-2 border-priimary-blue md:w-[42%] border-primary-blue ">
            English मा :{" "}
            <input
              {...register(`company_name`, {
                // required: false,
              })}
              className="md:w-[70%] pl-3 text-primary-blue outline-none"
              type="text"
            />
          </div>
          <div className=" px-5 py-2 border-priimary-blue border-t md:border-t-0  md:w-[42%] border-primary-blue ">
            नेपालीमा :{" "}
            <input
              {...register(`company_name_nep`, {
                // required: false,
              })}
              className="md:w-[70%] pl-3 text-primary-blue outline-none"
              type="text"
            />
          </div>
        </div>
        <div className="border-primary-blue flex text-primary-red  border-t md:flex-row flex-col  w-full text-base font-bold  sm:text-lg">
          <div className=" px-5 py-2 border-priimary-blue md:w-[20%] border-r-0 md:border-r border-primary-blue ">
            कम्पनीको ठेगाना :
          </div>
          <div className="border-r- px-5 py-2 border-priimary-blue md:w-[42%] border-t-0 border-primary-blue ">
            {" "}
            <input
              {...register(`company_address`, {
                // required: false,
              })}
              className="md:w-[70%] pl-3 text-primary-blue outline-none"
              type="text"
            />
          </div>
          </div>
        </div>

        <div className="w-full flex gap-1 md:flex-row flex-col items-center">
          <div className="mt-4 w-full">
            <div className="border-2 border-primary-blue">
              {/* <div> */}
              {ward_registration_v3.map((item, i) => {
                const { name, validation, ip1, type } = item;
                return (
                  
                    <div
                      key={i}
                      className=" border-primary-blue flex flex-col border-b md:flex-row  "
                    >
                      <div className="text-primary-red px-5 py-2  font-laila  sm:!w-[300px] font-bold">
                        {ip1}
                      </div>
                      <div className="md:border-l-2 border-l-0 md:border-t-0 border-t-1 border-primary-blue text-primary-red  px-10 text-lg font-bold">
                        <input
                          type={type}
                          className=" w-full py-2 outline-none "
                          {...register(`${name}`, { required: false,
                            onChange: (e) => {e.target.name === "paid_up_capital" && setAmount(e.target.value)}

                          
                          })}
                        />
                      </div>
                    </div>
                  
                );
              })}

              {/* </div> */}
            </div>
            <div className="bg-red-200 border-spacing-2  border-primary-blue border-x-2 border-b-2 border-t-0 font-Laila text-primary-blue font-bold  py-5 text-center">
              पुँजी र प्रकृतीको आधारमा तपाईको जम्मा लाग्ने रकम{" "}
              <span className="text-red-600">रु.{totalAmount}।– </span> मात्र
            </div>
          </div>
          <div className="border-primary-red text-primary-blue font-Laila text-center w-fit md:rounded-full  rounded-2xl border-2 p-2 text-base">
            प्रा.लि. कम्पनीलाई वडा कार्यालयमा दर्ता गर्दा लाग्ने शुल्क सम्बन्धि पूर्ण जानकारी लिनको लागि यहाँ <span data-bs-toggle="modal" data-bs-target="#exampleModalEdit"  className="text-primary-red cursor-pointer"> Click
            </span>  गर्नुहोस ।
            <PrivateCompanyModal paymentRangeList={paymentRangeList} />
          </div>
        </div>

        {/* <div className="overflow-x-auto">
          <div>
            <div>
              <div className="flex">
                <th className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                  कम्पनीको नाम
                </th>
                <div className="border-primary-blue flex text-primary-red border px-20 text-base font-bold sm:text-lg">
                  <p>English मा:</p>
                  <input
                  {...register(`company_name`, {
                    // required: false,
                  })}
                  />
                </div>
                <div className="border-primary-blue flex text-primary-red border px-20 text-base font-bold sm:text-lg">
                  <p>नेपालीमा : </p>
                  <input
                  {...register(`company_name_nep`, {
                    // required: false,
                  })}
                  />
                </div>
              </div>
              <div className="flex">
                <th className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                  कम्पनीको ठेगाना
                </th>
                <div className="border-primary-blue flex text-primary-red border px-20 text-base font-bold sm:text-lg">
                  <input 
                   {...register(`company_address`, {
                    // required: false,
                  })}
                  />
                </div>
              </div>
              <div className="flex">
                <th className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                  सम्बन्धित ब्यक्तीको नाम
                </th>
                <div className="border-primary-blue flex text-primary-red border px-20 text-base font-bold sm:text-lg">
                  <input 
                  {...register(`contact_person`, {
                    // required: false,
                  })}
                  />
                </div>
              </div>
              <div className="flex">
                <th className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                  सम्बन्धित ब्यक्तीको सम्पर्क नं.
                </th>
                <div className="border-primary-blue flex text-primary-red border px-20 text-base font-bold sm:text-lg">
                  <input
                  // conatact_number	
                  {...register(`conatact_number`, {
                    // required: false,
                  })}
                  />
                </div>
              </div>
              <div className="flex">
                <th className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
                  चुक्ता पुँजी
                </th>
                <div className="border-primary-blue flex text-primary-red border px-20 text-base font-bold sm:text-lg">
                  <input 
                  // paid_up_capital
                  {...register("paid_up_capital", { required: false })}
                  />
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <p className="text-primary-blue font-Calistoga py-3 text-lg underline">
          2. Details of Share Holders
        </p>

        <DetailsOfShareHolders
          DetailShareholder={Ward_details_of_shareholder_v2}
          needed_share={ward_shareholder_v2}
          setShareHolders={setShareHolders}
          shareHolders={shareHolders}
        />

        {/* <p className=" text-primary-blue">
          (साझेदार सदस्यहरुको विवरण) (२ वा २ भन्दा बढि साझेदार भएर दर्ता गर्दा
          यो फर्म अनिवार्य भर्नुपर्नेछ ।)
        </p> */}

        {/* share holder details form */}
        {/* <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
              <div className="min-w-[1300px] overflow-x-auto">
                <div id="tbl_posts">
                  <div>
                    <div>
                      <div className="border-primary-blue  text-primary-red border text-lg font-bold">
                        क्र. स.
                      </div>
                      <div className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
                        साझेदार सदस्यहरुको नाम
                      </div>
                      <div className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
                        हालको ठेगाना
                      </div>
                      <div className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
                        लगानी गर्ने शेयरको प्रतिशत
                      </div>
                      <div className="border-primary-blue text-primary-red border text-base font-bold sm:text-lg">
                        लगानी गर्ने शेयर रकम
                      </div>

                      <div className="border-primary-blue text-primary-red border border-r-0 text-base font-bold sm:text-lg">
                        शेयर सदस्यको नागरिकता
                      </div>
                      <div className="border-primary-blue text-primary-red border border-r text-base font-bold sm:text-lg">
                        पासपोर्ट साईजको फोटो
                      </div>
                    </div>
                  </div>
                  <tbody id="tbl_posts_body">
                    <div id="rec-1" className="border-primary-blue border">
                      <div className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                        1
                      </div>
                      <div className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </div>
                      <div className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </div>
                      <div className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </div>
                      <div className="p-0">
                        <input
                          type="text"
                          name=""
                          className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                          id=""
                        />
                      </div>
                      <div className="p-0">
                        <input
                          type="file"
                          name=""
                          className="border-primary-blue file:bg-primary-blue h-[54px] w-full cursor-pointer border-r py-3 px-3 outline-none file:rounded-2xl file:text-white"
                          id=""
                        />
                      </div>

                      <div className="p-0">
                        <input
                          type="file"
                          name=""
                          className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer py-3 px-3 outline-none file:rounded-2xl file:text-white"
                          id=""
                        />
                      </div>
                    </div>
                  </tbody>
                </div>
                <div style={{ display: "none" }}>
                  {/* div row add */}
        {/* <div id="sample_table">
                    <tbody>
                      <div id="" className="border-primary-blue border">
                        <div className="text-primary-red border-primary-blue border-r px-10 text-center font-semibold">
                          <span className="sn">1</span>
                        </div>
                        <div className="p-0">
                          <input
                            type="text"
                            name=""
                            className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                            id=""
                          />
                        </div>
                        <div className="p-0">
                          <input
                            type="text"
                            name=""
                            className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                            id=""
                          />
                        </div>
                        <div className="p-0">
                          <input
                            type="text"
                            name=""
                            className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                            id=""
                          />
                        </div>
                        <div className="p-0">
                          <input
                            type="file"
                            name=""
                            className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer border-r py-3 px-3 outline-none file:rounded-2xl file:text-white"
                            id=""
                          />
                        </div>
                        <div className="p-0">
                          <input
                            type="text"
                            name=""
                            className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                            id=""
                          />
                        </div>
                        <div className="p-0">
                          <input
                            type="text"
                            name=""
                            className="border-primary-blue text-primary-blue m-0 h-[54px] w-full border-r py-3 px-3 outline-none"
                            id=""
                          />
                        </div>
                        <div className="p-0">
                          <input
                            type="file"
                            name=""
                            className="border-primary-blue file:bg-primary-blue m-0 w-full cursor-pointer py-3 px-3 outline-none file:rounded-2xl file:text-white"
                            id=""
                          />
                        </div>
                        <div className="">
                          <a href="" className="delete-record">
                            <svg
                              className="text-primary-red h-8 w-8"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                              role="img"
                              preserveAspectRatio="xMidYMid meet"
                              viewBox="0 0 24 24"
                            >
                              <path
                                fill="currentColor"
                                d="M19.1 4.9C15.2 1 8.8 1 4.9 4.9S1 15.2 4.9 19.1s10.2 3.9 14.1 0s4-10.3.1-14.2zm-4.3 11.3L12 13.4l-2.8 2.8l-1.4-1.4l2.8-2.8l-2.8-2.8l1.4-1.4l2.8 2.8l2.8-2.8l1.4 1.4l-2.8 2.8l2.8 2.8l-1.4 1.4z"
                              />
                            </svg>
                          </a>
                        </div>
                      </div>
                    </tbody>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        {/* </div> */}
        {/* details of share holders close */}
        <div className="text-primary-blue font-Calistoga text-lg mt-6 mb-6 underline">
          3.Main Objective
          <span className="text-primary-blue font-Laila underline mx-2 ">
            ( यो व्यवसायले गर्ने मुख्य मुख्य कामहरु सहितको उद्देश्यहरु)
          </span>
        </div>
        <MainObjectives register={register} />
        <div className="text-primary-blue font-Calistoga text-lg mt-6 mb-6 underline">
          4. Upload Documents
          <span className="text-primary-blue underline font-Laila mx-2 ">
            (यो ब्यवसाय दर्ताको लागि आवश्यक पर्ने निम्न कागजपत्रहरु Upload
            गर्नुहोस् ।)
          </span>
        </div>
        <Documents
          documents_data={Ward_upload_details_v2}
          initialState={data}
          setDocument={setDocsOutput}
        />

        <div className="text-primary-blue font-Calistoga text-lg my-3 underline">
          5. Working Branch{" "}
          <span className="text-primary-blue font-Laila">
            {" "}
            (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन
            शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
          </span>
        </div>
        <FormBranch register={register} />
        <FormButtom />

        <FormPayment handleSubmit={handleSubmit} handleClick={handleClick}
        setUploadProof={setUploadProof}
        dueAmount = {dueAmount}
        setPaidAmount = {setPaidAmount}
        totalAmount={totalAmount}
        
        />
      </form>
    </div>
  );
};

export default WardRegistrationB;
